"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderHint = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
function SliderHint({ className }) {
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'SliderHint_Container', children: [(0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Triple_Arrow_Opacity, "data-e2e": 'SliderHint_StyledIcon' }), (0, jsx_runtime_1.jsx)(Label, { "data-e2e": 'SliderHint_Label', children: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.beatingHeart.sliderHint) })] }));
}
exports.SliderHint = SliderHint;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  color: ${({ theme }) => theme.textSecondary};
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 40px;
  height: 30px;

  transform: rotate(-90deg);
`;
const Label = styled_components_1.default.div `
  margin-top: 10px;

  font-size: 14px;

  user-select: none;
`;
